import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { DesktopBackground } from '../../../components/atoms/DesktopBackground';
import { Loading } from '../../../components/atoms/Loading';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      background: 'var(--color-white)',
      textAlign: 'center',
      '@media (min-width:768px)': {
        borderRadius: 10
      }
    },
    container: {
      background: 'var(--color-key)',
      minHeight: '100vh',
      textAlign: 'center',
      '& p': {
        margin: '24px 0 0',
        color: 'var(--color-white)',
        fontSize: 16,
        fontWeight: 500
      },
      '@media (min-width:768px)': {
        minHeight: 745,
        borderRadius: 10
      }
    },
    loadingContainer: {
      marginTop: 240,
      paddingTop: '50%'
    }
  })
);

const LoadingScreen: React.FC<{}> = () => {
  const styles = useStyles({});

  return (
    <DesktopBackground>
      <div className={styles.card}>
        <div className={styles.container}>
          <div className={styles.loadingContainer}>
            <Loading white />
            <p>データ読み込み中です...</p>
          </div>
        </div>
      </div>
    </DesktopBackground>
  );
};

export default LoadingScreen;
